export * from "./materialPluginManager.pure";
export * from "./materialPluginManager.types";

import { RegisterMaterialPluginManager } from "./materialPluginManager.pure";
RegisterMaterialPluginManager();
